var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import qs from 'qs';
import dayjs from 'dayjs';
import QRCode from 'qrcode-generator';
import { PAGE_MAX_WIDTH, IPHONE5_HEIGHT } from '@/constants';
import { ViewSizeType } from '../constants';
import { reportClickEvent } from '@/services/hotspotReport';
import { onlineDomain } from '@/config';
export function isTest() {
    return /(dbg.lizhiweike.com)|(tryweike.cn:3002)|(localhost)/.test(window.location.host);
}
export function isDevelopment() {
    return process.env.NODE_ENV === 'development';
}
export function isProduction() {
    return process.env.NODE_ENV === 'production';
}
export function formatPrice(price, fixLength) {
    if (fixLength === void 0) { fixLength = 2; }
    return (price / 100).toFixed(fixLength);
}
export function formatFloorPrice(price, fixLength) {
    if (fixLength === void 0) { fixLength = 2; }
    var priceText = (price / 100).toFixed(2);
    var endPosition = priceText.length - 2 + fixLength;
    if (priceText.length === endPosition + 2) {
        endPosition -= 1;
    }
    return priceText.substring(0, endPosition);
}
export function randomRange(min, max, isInt) {
    if (isInt === void 0) { isInt = true; }
    if (isInt) {
        return parseInt((Math.random() * (max - min + 1) + min).toString(), 10);
    }
    return Math.random() * (max - min + 1) + min;
}
export function isPC() {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        return false;
    }
    else {
        return true;
    }
}
export function isIOS() {
    return /(iPhone|iPod|ios)/i.test(navigator.userAgent);
}
export function isAndroid() {
    return (navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Adr') > -1);
}
export var isMouseEvent = function (event) { return !!(event.type.indexOf('mouse') !== -1); };
export function setEvent(params) {
    window._czc &&
        window._czc.push([
            '_trackEvent',
            params.page || 'common',
            params.action || 'click',
            params.name || '',
            params.label || 1,
        ]);
}
export function cnzzSendEvent(name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                setEvent({ name: name });
            }
            catch (err) {
                console.log(err);
            }
            return [2 /*return*/];
        });
    });
}
export function cnzzSendObjectEvent(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setEvent(params);
            return [2 /*return*/];
        });
    });
}
export function burryPoint(params) {
    try {
        if (typeof params === 'string') {
            cnzzSendEvent(params);
            window.TorDataService.emitAction(params);
        }
        else {
            cnzzSendObjectEvent(params);
            window.TorDataService.emitAction(params.action || params.name, params);
        }
    }
    catch (error) {
    }
}
export function formatPath(url, query) {
    if (query) {
        url += "?" + qs.stringify(query);
    }
    return url;
}
export function previewLoadImages(list, allowFail, crossOrigin) {
    if (allowFail === void 0) { allowFail = true; }
    if (crossOrigin === void 0) { crossOrigin = true; }
    return Promise.all(list.map(function (item) {
        return new Promise((function (resolve, reject) {
            var img = new Image();
            if (crossOrigin) {
                img.setAttribute("crossOrigin", 'Anonymous');
            }
            img.src = item;
            img.onload = function () { return resolve(img); };
            img.onerror = function () {
                if (allowFail) {
                    resolve(img);
                }
                else {
                    reject(img);
                }
            };
        }));
    }));
}
export function previewLoadImage(url, allowFail, crossOrigin) {
    if (allowFail === void 0) { allowFail = true; }
    if (crossOrigin === void 0) { crossOrigin = true; }
    return new Promise(function (resolve, reject) {
        var img = new Image();
        if (crossOrigin) {
            img.setAttribute("crossOrigin", 'Anonymous');
        }
        img.src = url;
        img.onload = function () { return resolve(img); };
        img.onerror = function () {
            if (allowFail) {
                resolve(img);
            }
            else {
                reject(img);
            }
        };
    });
}
export function ABTestShow() {
    return __awaiter(this, void 0, void 0, function () {
        var account;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) {
                        window.Session.getToken(function (account) {
                            resolve(account);
                        });
                    })];
                case 1:
                    account = _a.sent();
                    return [2 /*return*/, parseInt(account.id.toString().substring(account.id.toString().length - 1)) >= 5];
            }
        });
    });
}
export function isLZWKAPP() {
    return /lycheer/.test(navigator.userAgent.toLocaleLowerCase());
}
export function todayTimeRemaining() {
    return Math.floor(dayjs().startOf('day').add(1, 'day').diff(dayjs()) / 1000);
}
export function isLocalhost() {
    return window.location.host.indexOf('localhost') !== -1;
}
export function getLocationParams() {
    return qs.parse(window.location.search.replace('?', ''));
}
export function getLocationParamValue(key) {
    return qs.parse(window.location.search.replace('?', ''))[key];
}
export function makeRetainQrcode(content) {
    var qr = QRCode(0, 'L');
    qr.addData(content);
    qr.make();
    return qr.createDataURL(5);
}
export function getParamsFromUrl() {
    var query = location.search.substr(1);
    var result = {};
    query.split("&").forEach(function (part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}
export function isExistInUrl(url) {
    return (window.location.pathname.indexOf(url) > -1);
}
/**
 * 为了性能，useWindowSize要在hooks里面用
 * @param size
 * @param initViewWidth
 */
export function computedSizePx(size, initViewWidth) {
    if (initViewWidth === void 0) { initViewWidth = 370; }
    var viewWidth = document.body.clientWidth > PAGE_MAX_WIDTH
        ? PAGE_MAX_WIDTH
        : document.body.clientWidth;
    var scale = size / initViewWidth;
    return viewWidth * scale + 'px';
}
export function computedSizeByHeight(size, initViewHeight) {
    if (initViewHeight === void 0) { initViewHeight = IPHONE5_HEIGHT; }
    var viewHeight = document.body.clientHeight;
    var scale = size / initViewHeight;
    return viewHeight * scale;
}
export function computedSizePxByHeight(size, initViewHeight) {
    if (initViewHeight === void 0) { initViewHeight = IPHONE5_HEIGHT; }
    var viewHeight = document.body.clientHeight;
    var scale = size / initViewHeight;
    return viewHeight * scale + 'px';
}
export function formatNumber(num) {
    if (num < 10000) {
        return num.toString();
    }
    else if (num < 1000000) {
        return parseFloat((num / 1000).toFixed(2)) + 'k';
    }
    else {
        return parseFloat((num / 10000).toFixed(2)) + 'w';
    }
}
export function lockContaier(id) {
    var element = document.getElementById(id);
    if (!element)
        return;
    var style = window.getComputedStyle(element);
    window['lockBodyElement'] = {
        height: style.height,
        overflowY: style.overflowY,
        scrollTop: element.scrollTop
    };
    element.style.overflowY = 'hidden';
}
export function unlockContaier(id) {
    var element = document.getElementById(id);
    if (!element || !window['lockBodyElement'])
        return;
    var _a = window['lockBodyElement'].scrollTop, scrollTop = _a === void 0 ? 0 : _a;
    element.style.overflowY = 'auto';
    try {
        element.scrollTo(0, scrollTop);
    }
    catch (error) {
    }
    delete window['lockBodyElement'];
}
/**
 * 微信有返回键情况下
 */
export function getViewSizeType() {
    var width = window.innerWidth > PAGE_MAX_WIDTH ? PAGE_MAX_WIDTH : window.innerWidth;
    var scale = window.innerHeight / width;
    var lagre = 2.16; // phoneX 812/375
    var normal = 1.7; //
    var small = 1.6; // iphone7 557/375 
    if (scale > lagre) {
        return ViewSizeType.LARGE;
    }
    else if (scale > normal) {
        return ViewSizeType.NORMAL;
    }
    else if (scale > small) {
        return ViewSizeType.SMALL;
    }
    else {
        return ViewSizeType.XSMALL;
    }
}
export function formatPointNumber(num) {
    var formatNum = num;
    var unit = '';
    if (num < 100000) {
        formatNum = num;
    }
    else if (num < 10000000) {
        formatNum = Math.floor((num / 1000));
        unit = 'k';
    }
    else {
        formatNum = Math.floor((num / 10000));
        unit = 'w';
    }
    return {
        formatNum: formatNum,
        unit: unit
    };
}
export function numberToChinese(num) {
    switch (num) {
        case 0: return '零';
        case 1: return '一';
        case 2: return '二';
        case 3: return '三';
        case 4: return '四';
        case 5: return '五';
        case 6: return '六';
        case 7: return '七';
        case 8: return '八';
        case 9: return '九';
    }
    throw new Error("num \u592A\u5927," + num);
}
// 防抖
export function debounce(func, wait) {
    var timer = 0;
    return function () {
        if (timer !== null) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(func, wait);
    };
}
// 节流
export function throttle(func, delay) {
    var prev = 0;
    var timer = 0;
    function runFunc() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        func.apply(void 0, args);
        prev = Date.now();
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        window.clearTimeout(timer);
        var delta = Date.now() - prev;
        if (delta >= delay) {
            runFunc.apply(void 0, args);
        }
        else {
            timer = window.setTimeout(function () { return runFunc.apply(void 0, args); }, delay - delta);
        }
    };
}
export function judgeAPPVersion(num) {
    var userAgent = navigator.userAgent.toLowerCase();
    var version = userAgent.match(/lycheer\/(\d)+.(\d)+.(\d)/);
    var versionNumber = version ? parseInt(version[0].replace('lycheer/', '').replace(/\./g, "")) : '';
    return versionNumber >= num;
}
export function goBack() {
    if (isAndroid()) {
        if (window.WKApp) {
            window.WKApp.goBackPrePage();
        }
    }
    if (isIOS()) {
        window.webkit.messageHandlers.WKApp.postMessage({
            function: "goBackPrePage"
        });
    }
}
export function renderMoney(money) {
    return (money / 100.0).toFixed(2);
}
export function renderPopularCn(num) {
    if (num < 1e4) {
        return num;
    }
    else {
        return +(num / 1e4).toFixed(1) + "\u4E07";
    }
}
export function getPicture(url, width, format, quality) {
    if (width === void 0) { width = 300; }
    if (format === void 0) { format = 'normal'; }
    if (quality === void 0) { quality = 85; }
    if (format === 'webp') {
        return deletePictureParams(url) + "?imageView2/format/webp/2/w/" + width + "/q/" + quality + "!";
    }
    else {
        return deletePictureParams(url) + "?imageView2/2/w/" + width + "/q/" + quality + "!";
    }
}
export function deletePictureParams(str) {
    try {
        var len = 0;
        if (str.lastIndexOf('jpg') > -1) {
            len = str.lastIndexOf('jpg') + 3;
            return str.substr(0, len);
        }
        else if (str.lastIndexOf('png') > -1) {
            len = str.lastIndexOf('png') + 3;
            return str.substr(0, len);
        }
        else if (str.lastIndexOf('jpeg') > -1) {
            len = str.lastIndexOf('jpeg') + 4;
            return str.substr(0, len);
        }
        else if (str.lastIndexOf('JPEG') > -1) {
            len = str.lastIndexOf('JPEG') + 4;
            return str.substr(0, len);
        }
        else if (str.lastIndexOf('PNG') > -1) {
            len = str.lastIndexOf('PNG') + 3;
            return str.substr(0, len);
        }
        else if (str.lastIndexOf('JPG') > -1) {
            len = str.lastIndexOf('JPG') + 3;
            return str.substr(0, len);
        }
        else {
            return str;
        }
    }
    catch (e) {
        console.log(e);
        return str;
    }
}
export function easeInOutCubic(pos) {
    if ((pos /= 0.5) < 1)
        return 0.5 * Math.pow(pos, 3);
    return 0.5 * (Math.pow(pos - 2, 3) + 2);
}
export function renderPopular(num) {
    if (num < 1e4) {
        return num;
    }
    else {
        return +(num / 1e4).toFixed(1) + "W";
    }
}
export function goToChannel(channelId, hasAuth) {
    if (hasAuth) {
        if (isLZWKAPP()) {
            return location.assign("lizhiweike://channel?channel_id=" + channelId);
        }
        return window.location.assign(onlineDomain + "/channel2/" + channelId + "?fr_from=simple-detail");
    }
    if (isTest()) {
        window.location.assign("/operation-business/simple-detail?fr_from=double-egg&id=" + channelId);
    }
    else {
        window.location.assign(onlineDomain + "/operation-business/simple-detail?fr_from=double-egg&id=" + channelId);
    }
}
export function isSupportWebp() {
    try {
        return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
    }
    catch (err) {
        return false;
    }
}
export function renderWebpOrNormalPic(url, width, quality) {
    if (width === void 0) { width = 400; }
    if (quality === void 0) { quality = 85; }
    if (isSupportWebp()) {
        return deletePictureParams(url) + "?imageView2/format/webp/2/w/" + width + "/q/" + quality + "!";
    }
    else {
        return deletePictureParams(url) + "?imageView2/2/w/" + width + "/q/" + quality + "!";
    }
}
export function isWhiteListTest() {
    return true;
    // return getLocationParamValue('is_white_list_test') === 'true';
}
//用法--TimeStream(1500614243, 'CN-YMD')
export function TimeStream(timestamp, type) {
    var date = new Date(timestamp * 1000);
    var Y = date.getFullYear();
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    switch (type) {
        case 'YMD': //年-月-日
            return Y + '-' + M + '-' + D;
        case 'MD': //月-日
            return M + '-' + D;
        case 'MD_HM': //月-日 时-分
            return M + '-' + D + ' ' + h + ':' + m;
        case 'YMD_HMS': // 月-日 时：分：秒
            return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
        case 'CN_YMD': //x年x月x日
            return Y + '年' + M + '月' + D + '日';
        case 'CN_YMD_HM': //x年x月x日
            return Y + '年' + M + '月' + D + '日' + ' ' + h + ':' + m;
        case 'CN_MD_HM': //x月x日
            return M + '月' + D + '日' + ' ' + h + ':' + m;
        case 'hm': // 时:分
            return h + ':' + m;
        case '-D': //天数差
            return Math.floor(((timestamp * 1000) - Date.parse(new Date())) / 1000 / 3600 / 24);
        case '-H': //小时差
            return Math.ceil((timestamp * 1000 - Date.parse(new Date())) / 1000 / 3600);
        default: //年-月-日 时:分
            return Y + '-' + M + '-' + D + ' ' + h + ':' + m;
    }
}
export function AllowPass(_a) {
    var whitepercent = _a.whitepercent, whiteaccount = _a.whiteaccount;
    return __awaiter(this, void 0, void 0, function () {
        var userInfo, accountId, toStringId, lastNumber, percent;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (getLocationParamValue('origin')) {
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            return window.Session.getToken(function (_a) {
                                var account = _a.account;
                                return resolve(account);
                            });
                        })];
                case 1:
                    userInfo = _b.sent();
                    accountId = userInfo.id;
                    if (whiteaccount.length > 0 && whiteaccount.includes(accountId)) {
                        return [2 /*return*/, true];
                    }
                    else {
                        toStringId = accountId.toString();
                        lastNumber = parseInt(toStringId.slice(toStringId.length - 1, toStringId.length));
                        percent = whitepercent / 10;
                        if (lastNumber < percent) {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * 动画垂直滚动到页面指定位置
 * @param { Number } currentY 当前位置
 * @param { Number } targetY 目标位置
 */
export function scrollAnimation(_currentYs, targetY) {
    var currentY = _currentYs ? _currentYs : document.documentElement.scrollTop || document.body.scrollTop;
    // 获取当前位置方法
    // const currentY = document.documentElement.scrollTop || document.body.scrollTop
    // 计算需要移动的距离
    var needScrollTop = targetY - currentY;
    var _currentY = _currentYs ? _currentYs : currentY;
    setTimeout(function () {
        // 一次调用滑动帧数，每次调用会不一样
        var dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
            scrollAnimation(_currentY, targetY);
        }
        else {
            window.scrollTo(_currentY, targetY);
        }
    }, 1);
}
export function checkWebp() {
    try {
        return (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0);
    }
    catch (err) {
        return false;
    }
}
export function repeat(arr, length) {
    return Array.from(Array(length)).reduce(function (acc, _, i) {
        return acc.concat(arr[i % arr.length]);
    }, []);
}
export function srollToTarget(role) {
    var tabbar = document.querySelector('[data-role="' + role + '"]');
    if (tabbar) {
        var userScrollNow = document.documentElement.scrollTop + document.body.scrollTop;
        var getTop = tabbar.getBoundingClientRect().top;
        scrollAnimation(undefined, userScrollNow + getTop);
    }
}
export function MixReport(element, evt_params) {
    if (evt_params === void 0) { evt_params = {}; }
    try {
        cnzzSendEvent(element);
        reportClickEvent(element, evt_params);
    }
    catch (err) { }
}
export function changePxTovWAndAdjacency(w, h) {
    var retObj = {};
    if (w) {
        retObj.width = (w / 375) * 100 + "vw";
        retObj.maxWidth = (w / 375) * 480;
    }
    if (h) {
        retObj.height = (h / 375) * 100 + "vw";
        retObj.maxHeight = (h / 375) * 480;
    }
    return retObj;
}
//页面埋点 玄武+cnzz
export function setPageData(evt, params) {
    try {
        window.TorDataService &&
            window.TorDataService.emitAction(evt, __assign({}, params));
    }
    catch (err) { }
}
// 判断是否是pc端
export var isPcEnv = function () {
    var session = window.Session;
    return session.payPlatform === 'pc' ? true : false;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/util.ts
// module id = 48
// module chunks = 39